<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-coordinate`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 44a1 1 0 01-1-1v-2a1 1 0 011-1h3v-6.132C14.662 32.89 9 26.606 9 19c0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 7.606-5.661 13.89-13 14.868V40h3a1 1 0 011 1v2a1 1 0 01-1 1H19zm5-36c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11S30.075 8 24 8zm7.996 12.72C31.848 15.327 27.43 11 22 11v4l.225.004A6 6 0 0128 21h4l-.004-.28z"/></svg>
</template>
<script>

export default {
  name: 'IconCoordinate',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
